const windLoadData = [
  { size: '15-20 Pax (5m x 5m)', maxWind: '55 mph', gustRating: '70 mph', surfaceArea: '25 m²', upliftForce: '1,240 lbf' },
  { size: '25-30 Pax (6m x 6m)', maxWind: '52 mph', gustRating: '65 mph', surfaceArea: '36 m²', upliftForce: '1,785 lbf' },
  { size: '65-70 Pax (9m x 9m)', maxWind: '48 mph', gustRating: '60 mph', surfaceArea: '81 m²', upliftForce: '3,880 lbf' },
  { size: '150-180 Pax (12m x 12m)', maxWind: '45 mph', gustRating: '55 mph', surfaceArea: '144 m²', upliftForce: '6,480 lbf' },
  { size: '300 Pax (15m x 15m)', maxWind: '42 mph', gustRating: '50 mph', surfaceArea: '225 m²', upliftForce: '9,450 lbf' },
  { size: '500 Pax (20m x 20m)', maxWind: '38 mph', gustRating: '45 mph', surfaceArea: '400 m²', upliftForce: '15,200 lbf' },
];

export default function WindLoadCalculations() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-14">
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
            Structural Wind Load Calculations
          </h2>
          <p className="text-gray-500 text-base max-w-3xl leading-relaxed">
            All Pop Pro Tents are independently analyzed for wind loading per ASCE 7-16 standards. Each tent size has a corresponding
            wind load report detailing sustained wind ratings, gust tolerance, uplift forces, and recommended anchoring patterns for
            various soil conditions.
          </p>
        </div>

        {/* Wind Load Table */}
        <div className="overflow-x-auto mb-14 rounded-xl border border-gray-200 bg-white">
          <table className="w-full text-left text-sm">
            <thead className="bg-gray-100 text-gray-700 font-semibold">
              <tr>
                <th className="px-6 py-4 whitespace-nowrap">Tent Size</th>
                <th className="px-6 py-4 whitespace-nowrap">Max Sustained Wind</th>
                <th className="px-6 py-4 whitespace-nowrap">Gust Rating</th>
                <th className="px-6 py-4 whitespace-nowrap">Surface Area</th>
                <th className="px-6 py-4 whitespace-nowrap">Uplift Force</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {windLoadData.map((row) => (
                <tr key={row.size} className="hover:bg-gray-50/70 transition-colors">
                  <td className="px-6 py-4 font-medium text-gray-900">{row.size}</td>
                  <td className="px-6 py-4 text-gray-600">{row.maxWind}</td>
                  <td className="px-6 py-4 text-gray-600">{row.gustRating}</td>
                  <td className="px-6 py-4 text-gray-600">{row.surfaceArea}</td>
                  <td className="px-6 py-4 text-gray-600">{row.upliftForce}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Structural analysis diagram */}
        <div className="rounded-xl border border-gray-200 overflow-hidden bg-white">
          <img
            src="/assets/img/structural-diagram-01.webp"
            alt="Structural analysis diagrams showing storm belt forces, cable forces, and deflection analysis across a Pop Pro stretch tent, engineered to ASCE 7-16 and international standards"
            className="w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
}